module.exports = __webpack_public_path__ + "static/media/laptop-build.68153d34.png";